import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Form,
  Checkbox
} from 'react-bootstrap';
import { Link } from 'react-router';
import { goal } from 'kodyl-js/tracking';
import tracking from '../utils/tracking';
import i18n from 'kodyl-js/i18n/react';
import FacebookLogin from '../common/facebook-login';
import TermsModal from '../common/modal/terms';
import LastDwelling from '../common/last-dwelling';
import LoadingSpinner from '../common/loading-spinner';
import ErrorMessage from '../common/error-message';
import { CREATE_FAIL } from '../redux/modules/auth';
import { getLoginPath, toUserFlowNext } from './redirection';

const EMAIL = 'email';
const PASSWORD = 'password';

function validName(name) {
  if (name.length > 50) {
    return false;
  }
  if (/http/.test(name)) {
    return false;
  }
  if (/[-_/()!?;:–*",.]+/.test(name)) {
    return false;
  }

  return true;
}

@i18n
class Signup extends Component {
  constructor(props) {
    super(props);
    this._ref = {};
    this.state = {
      showModal: false,
      failed: false,
      loading: false,
      errMsg: null
    };
  }

  componentWillReceiveProps(nextProps) {
    const { user, subscriber } = nextProps;
    toUserFlowNext({ user, subscriber });
  }

  modalShow = e => {
    e.preventDefault();
    this.setState({ showModal: true });
  };

  modalClose = () => {
    this.setState({ showModal: false });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { sessionPrefs } = this.props;

    const user = Object.keys(this._ref).reduce((acc, input) => {
      const node = ReactDOM.findDOMNode(this._ref[input]);
      acc[input] = node.type === 'checkbox' ? node.checked : node.value;

      return acc;
    }, {});

    const {
      email,
      name,
      password,
      password2,
      terms,
      consent_communication
    } = user;

    if (!terms) {
      return this.setState({ loading: false, failed: true, errMsg: 'terms' });
    }
    if (password.trim() !== password2.trim()) {
      return this.setState({ loading: false, failed: true, errMsg: PASSWORD });
    }
    if (!validName(name)) {
      return this.setState({ loading: false, failed: true, errMsg: 'name' });
    }

    if (email && name && password) {
      this.setState({ loading: true, failed: false, errMsg: null });

      this.props
        .createUser({
          email,
          name,
          password: password.trim(),
          terms,
          consent_communication,
          sessionPrefs
        })
        .then(action => {
          const meta = action.payload.meta;
          const offer = meta
            ? meta.filter(m => m.identifer === 'subscr/2016-07')[0]
            : null;

          if (offer) {
            tracking.event('subscription', 'offer-assigned', offer.value);
          }

          if (action.type === CREATE_FAIL) {
            this.setState({ failed: true, loading: false });
          } else {
            goal({ name: 'CompleteRegistration' });
          }
          return action;
        })
        .catch(err => {
          if (__DEV__) {
            console.error(err);
          }
          let errMsg = 'generic';
          if (err.statusCode === 422) {
            const {
              response: { errors = {} }
            } = err;
            errMsg =
              Object.keys(errors).reduce((field, key) => {
                return field || errors[key].path === 'email'
                  ? /cannot be blank/.test(errors[key].message)
                    ? 'emailEmpty'
                    : 'emailExists'
                  : errors[key].path;
              }, null) || 'generic';
          }
          this.setState({ failed: true, loading: false, errMsg });
        });
    }
  };

  outputErrMsg = () => {
    const { errMsg } = this.state;
    const messages = {
      emailExists: this.i18n('Email-adressen er allerede i brug.'),
      emailEmpty: this.i18n(
        'Email-feltet er enten tomt eller ikke udfyldt korrekt. Her er et eksempel på en korrekt udfyldt email: mail@mail.dk'
      ),
      password: this.i18n('Adgangskoderne er ikke ens.'),
      terms: this.i18n("Du har ikke godkendt Boligninja's vilkår."),
      generic: this.i18n(
        'Oops! Something went wrong. Please try again or reach out to our customer support.'
      )
    };

    return messages[errMsg];
  };

  render() {
    const { showModal, failed, loading, errMsg } = this.state;

    return (
      <Grid>
        <LastDwelling page="signup" />
        <h2>{this.i18n('Create profile')}</h2>
        <Row>
          <Col sm={8}>
            <Form
              horizontal
              onSubmit={this.handleSubmit}
              action=""
              name="form"
              autoComplete="on"
              className="form-glyph-left"
            >
              <FormGroup>
                <Col componentClass={ControlLabel} sm={4}>
                  {`${this.i18n('Name')} *`}
                </Col>
                <Col sm={8}>
                  <FormControl
                    type="text"
                    name="name"
                    placeholder={this.i18n('Name')}
                    ref={ref => (this._ref.name = ref)}
                    required
                  />
                </Col>
              </FormGroup>
              <FormGroup validationState={errMsg === EMAIL ? 'error' : null}>
                <Col componentClass={ControlLabel} sm={4}>
                  {`${this.i18n('Email address')} *`}
                </Col>
                <Col sm={8}>
                  <FormControl
                    type="email"
                    name="email"
                    placeholder={this.i18n('email')}
                    ref={ref => (this._ref.email = ref)}
                    required
                  />
                  <FormControl.Feedback />
                </Col>
              </FormGroup>
              <FormGroup validationState={errMsg === PASSWORD ? 'error' : null}>
                <Col componentClass={ControlLabel} sm={4}>
                  {`${this.i18n('Password')} *`}
                </Col>
                <Col sm={8}>
                  <FormControl
                    type="password"
                    name="password"
                    placeholder={this.i18n('Password')}
                    ref={ref => (this._ref.password = ref)}
                    required
                  />
                  <FormControl.Feedback />
                </Col>
              </FormGroup>
              <FormGroup validationState={errMsg === PASSWORD ? 'error' : null}>
                <Col componentClass={ControlLabel} sm={4}>
                  {`${this.i18n('Password (again)')} *`}
                </Col>
                <Col sm={8}>
                  <FormControl
                    type="password"
                    name="password-verify"
                    placeholder={this.i18n('Password (again)')}
                    ref={ref => (this._ref.password2 = ref)}
                    required
                  />
                  <FormControl.Feedback />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={4}>
                  {this.i18n('Confirm conditions')}
                </Col>
                <Col sm={8}>
                  <Checkbox
                    type="checkbox"
                    name="terms"
                    inputRef={ref => (this._ref.terms = ref)}
                    required
                  >
                    <span>
                      {this.i18n('I have read and accept')}
                      <Link
                        to="/info/terms"
                        target="_blank"
                        onClick={this.modalShow}
                      >
                        &nbsp;
                        {this.i18n(
                          'The terms of use and privacy policy of Boligninja'
                        )}
                      </Link>
                    </span>
                  </Checkbox>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col componentClass={ControlLabel} sm={4} />
                <Col sm={8}>
                  <Checkbox
                    type="checkbox"
                    name="consent_communication"
                    inputRef={ref => (this._ref.consent_communication = ref)}
                  >
                    <span>
                      Jeg ønsker besked om nye boliger og flytterelevant info
                      fra Boligninja som udspecificeret i{' '}
                      <Link
                        to="/info/terms#elektronisk-kommunikation"
                        target="_blank"
                        onClick={this.modalShow}
                      >
                        vilkårene
                      </Link>
                      .
                    </span>
                  </Checkbox>
                </Col>
              </FormGroup>
              {loading || failed ? (
                <FormGroup>
                  <Col xs={12}>
                    {failed ? (
                      <ErrorMessage text={this.outputErrMsg()} />
                    ) : null}
                    {loading ? <LoadingSpinner /> : null}
                  </Col>
                </FormGroup>
              ) : null}
              <FormGroup>
                <Col smOffset={4} sm={8}>
                  <button
                    type="submit"
                    disabled={loading}
                    className="btn btn-success btn-block"
                  >
                    <i
                      className="fa fa-user"
                      style={{
                        marginRight: '0.5em',
                        width: '1.28571429em',
                        textAlign: 'center'
                      }}
                    />
                    {this.i18n('Create profile')}
                  </button>
                </Col>
              </FormGroup>
            </Form>
          </Col>
          <Col sm={4}>
            <h4 style={{ marginTop: 0 }}>{this.i18n('Already got a user?')}</h4>
            <Link to={getLoginPath()}>
              {this.i18n('Click here and sign in')}
            </Link>
            ,&nbsp;
            {this.i18n('If you already have a user account.')}
            <hr />
            <FacebookLogin />
          </Col>
        </Row>
        <TermsModal onClose={this.modalClose} show={showModal} />
      </Grid>
    );
  }
}

export default Signup;
